__turbopack_context__.v({
  "hamburger": "Navbar-module__cJzEcG__hamburger",
  "hamburgerOpen": "Navbar-module__cJzEcG__hamburgerOpen",
  "logo": "Navbar-module__cJzEcG__logo",
  "logoImage": "Navbar-module__cJzEcG__logoImage",
  "logoText": "Navbar-module__cJzEcG__logoText",
  "navCTA": "Navbar-module__cJzEcG__navCTA",
  "navInner": "Navbar-module__cJzEcG__navInner",
  "navLink": "Navbar-module__cJzEcG__navLink",
  "navLinks": "Navbar-module__cJzEcG__navLinks",
  "navLinksOpen": "Navbar-module__cJzEcG__navLinksOpen",
  "navbar": "Navbar-module__cJzEcG__navbar",
  "overlay": "Navbar-module__cJzEcG__overlay",
  "overlayVisible": "Navbar-module__cJzEcG__overlayVisible",
  "scrolled": "Navbar-module__cJzEcG__scrolled",
});
